export const constant_productCategory = [
  "Raw Materials",
  "Finish Product",
  "Consumables",
  // "Semi-Finished Product",
  // "Packaging",
];
